import { createAction } from "@reduxjs/toolkit";
export var ActionTypes;
(function (ActionTypes) {
    ActionTypes["fetch"] = "searchAiSummary/fetch";
    ActionTypes["fetchSuccess"] = "searchAiSummary/fetchSuccess";
    ActionTypes["fetchError"] = "searchAiSummary/fetchError";
})(ActionTypes || (ActionTypes = {}));
export const actions = {
    fetch: createAction(ActionTypes.fetch, () => ({
        payload: {}
    })),
    fetchSuccess: createAction(ActionTypes.fetchSuccess, (data) => ({
        payload: { data }
    })),
    fetchError: createAction(ActionTypes.fetchError, (error) => ({
        payload: { error }
    }))
};
